/**
 * Reference Code Mapping for Garden
 * Maps field names to Evaluate codes (resourceCode in Item Library API)
 */

export interface GardenReferenceCodeMapping {
  code?: string;
}

/**
 * Garden Reference Codes
 * Maps field names from garden tables to Evaluate codes
 */
export const GARDEN_REFERENCES: Record<
  string,
  GardenReferenceCodeMapping
> = {
  // Base measurements (no codes - just quantities)
  scaffoldPlatform: {},

  // Ground Preparation
  thickNoDigLayer: { code: "GWALPGW033" }, // 150mm thick 'no dig' layer
  geotextileLayer: { code: "GWALP014" },
  plotClearance: { code: "GWALPGW001" }, // Remove general builders rubbish prior to topsoiling

  // Subsoil Works
  spreadLevelCleanSubsoilCapSiteWon: { code: "GWALPGW034" }, // Spread and level xxxmm thick site won clean subsoil capping layer
  spreadLevelCleanSubsoilCapImported: { code: "GWALPGW036" }, // Spread and level xxxmm thick imported clean subsoil capping layer

  // Topsoil & Finishing
  harrowGardens: { code: "GWALPGW042" }, // Harrow gardens to 300mm depth
  spreadLevelTopsoilSiteWon: { code: "GWALPGW002" }, // Spread and level xxxmm thick site won topsoil
  spreadLevelTopsoilImported: { code: "GWALPGW035" }, // Spread and level xxxmm thick imported topsoil
};

/**
 * Get reference code for a specific field
 */
export const getGardenReferenceCode = (
  referenceKey: string,
): string | undefined => {
  return GARDEN_REFERENCES[referenceKey]?.code;
};

/**
 * Get full reference information for a specific field
 */
export const getGardenReference = (
  referenceKey: string,
): GardenReferenceCodeMapping | undefined => {
  return GARDEN_REFERENCES[referenceKey];
};
